import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { PermissionStorageService } from "src/app/authentication/storages/permission-storage.service";
import { environment } from "src/environments/environment";

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({
    selector: "[permissionIf]",
    standalone: false
})
export class PermissionIfDirective implements OnInit {
  constructor(
    private permissionStore: PermissionStorageService,
    private container: ViewContainerRef,
    private template: TemplateRef<any>
  ) {}

  sub: Subscription;

  @Input() permissionIf: string;

  @Input() permissionIfElse: TemplateRef<any>;

  ngOnInit() {
    const permissions = this.permissionStore.getPermissions();

    this.container.clear();


    const permission = permissions?.find(
      (name) => name === this.permissionIf
    );

    if (permission) {
      this.container.createEmbeddedView(this.template);
    } else if (this.permissionIfElse) {
      this.container.createEmbeddedView(this.permissionIfElse);
    }
  }
}

@Directive({
    selector: "[permissionIfNot]",
    standalone: false
})
export class PermissionIfNotDirective implements OnInit {
  constructor(
    private permissionStore: PermissionStorageService,
    private container: ViewContainerRef,
    private template: TemplateRef<any>
  ) {}

  @Input() permissionIfNot: string;

  ngOnInit() {
    const permissions = this.permissionStore.getPermissions();
    this.container.clear();

    const hasPermission = permissions?.find(
      (name) => name === this.permissionIfNot
    );

    if (!hasPermission) {
      this.container.createEmbeddedView(this.template);
    }
  }
}